import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';
import './index.css';

const root = document.getElementById('root');
if (!root) throw new Error('Branchworks runtime: missing #root element in index.html');

createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
